import React, { Component } from "react";

class ChildBenefits extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <section className="child-detail__item child-detail__benefits">
        <p className="benefits__title beta">What your sponsored child gets</p>
        <div className="benefits__item media">
          <div className="media__img">
            <img className="benefits-item__image" src="https://wvusstatic.com/sponsorship-app/survive_to_thrive.svg" height="150" width="150" alt="Orange and white illustration of a photo of a sponsored child"/>
          </div>
          <div className="media__content">
            <p className="benefits-item__title zeta">Sponsored children go from surviving to thriving</p>
            <p className="benefits-item__description">Through World Vision{"'"}s work, every 60 seconds a family receives the tools to overcome poverty. Sponsorship helps address the specific needs of each community, empowering your child, their family, and community to become self-sufficient.</p>
          </div>
        </div>
        <div className="benefits__item media media">
          <div className="media__img">
            <img className="benefits-item__image" src="https://wvusstatic.com/sponsorship-app/encouragment.svg" height="150" width="150" alt="Orange and white illustration of an envelop opening to show a letter from a sponsored child"/>
          </div>
          <div className="media__content">
            <p className="benefits-item__title zeta">Sponsored children get encouragement</p>
            <p className="benefits-item__description">Your child can experience your love and encouragement through letters and photos, gifts, or even a visit! You can also send your child an email and get updates through the My World Vision app. Meanwhile, your sponsored child will get regular check-ins from local staff on their progress and well-being.</p>
          </div>
        </div>
        <div className="benefits__item media">
          <div className="media__img">
            <img className="benefits-item__image" src="https://wvusstatic.com/sponsorship-app/love.svg" height="150" width="150" alt="Illustration of an orange heart with a white cross to symbolize God's love"/>
          </div>
          <div className="media__content">
            <p className="benefits-item__title zeta">Sponsored children experience God{"'"}s love</p>
            <p className="benefits-item__description">Our faith in Jesus motivates us to serve all children regardless of race, religion, ethnicity, or gender. We go where other organizations can{"'"}t. That means you can too.</p>
          </div>
        </div>
      </section>
    );
  }
}

export default ChildBenefits;
